import { render, staticRenderFns } from "./phhonor.vue?vue&type=template&id=1267b4a1"
import script from "./phhonor.vue?vue&type=script&lang=js"
export * from "./phhonor.vue?vue&type=script&lang=js"
import style0 from "./phhonor.vue?vue&type=style&index=0&id=1267b4a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports